"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// write code here
var table = document.querySelector("table");
var titleArr = table.querySelector("tr").querySelectorAll("th");
var tbody = table.querySelector("tbody");
var prev;
var officeChoice = [
    "Tokyo",
    "Singapore",
    "London",
    "New York",
    "Edinburgh",
    "San Francisco"
];
// Sort rows
titleArr.forEach(function(header, index) {
    header.addEventListener("click", function() {
        var rows = _to_consumable_array(tbody.querySelectorAll("tr"));
        var sortedRows = rows.sort(function(a, b) {
            var aText = a.children[index].textContent.trim();
            var bText = b.children[index].textContent.trim();
            var aNumber = parseFloat(aText.replace(/[$,]/g, ""));
            var bNumber = parseFloat(bText.replace(/[$,]/g, ""));
            if (prev === header.textContent) {
                if (!isNaN(aNumber) && !isNaN(bNumber)) return bNumber - aNumber;
                return bText.localeCompare(aText);
            } else if (prev !== header.textContent) {
                if (!isNaN(aNumber) && !isNaN(bNumber)) return aNumber - bNumber;
                return aText.localeCompare(bText);
            }
        });
        tbody.innerHTML = "";
        sortedRows.forEach(function(row) {
            return tbody.appendChild(row);
        });
        prev = header.textContent;
    });
});
// Select row
tbody.addEventListener("click", function(e) {
    // console.log(tbody.querySelectorAll('tr')[1].className.includes('active'))
    tbody.querySelectorAll("tr").forEach(function(row) {
        if (row.className.includes("active")) row.className = "";
    });
    e.target.parentElement.className = "active";
});
// Form
var body = document.querySelector("body");
var form = document.createElement("form");
body.appendChild(form);
form.className = "new-employee-form";
var button = document.createElement("button");
button.innerText = "Save to table";
function createInput(labelText, type, discribe) {
    var label = document.createElement("label");
    label.textContent = labelText;
    var input = document.createElement("input");
    input.type = type;
    input.name = discribe;
    input.dataset.qa = discribe;
    input.required = true;
    label.appendChild(input);
    return label;
}
var nameLabel = createInput("Name:", "text", "name");
var positionLabel = createInput("Position:", "text", "position");
var ageLabel = createInput("Age:", "number", "age");
var salarylabel = createInput("Salary:", "number", "salary");
var officeLabel = document.createElement("label");
officeLabel.textContent = "Office:";
var selectLabel = document.createElement("select");
selectLabel.name = "office";
selectLabel.dataset.qa = "office";
officeLabel.appendChild(selectLabel);
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = officeChoice[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var office = _step.value;
        var option = document.createElement("option");
        option.textContent = office;
        option.value = office;
        selectLabel.appendChild(option);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
form.appendChild(nameLabel);
form.appendChild(positionLabel);
form.appendChild(officeLabel);
form.appendChild(ageLabel);
form.appendChild(salarylabel);
form.appendChild(button);
button.addEventListener("click", function(e) {
    e.preventDefault();
    var formData = new FormData(form);
    var firstName = formData.get("name");
    var position = formData.get("position");
    var office = formData.get("office");
    var age = Number(formData.get("age"));
    var salary = Number(formData.get("salary"));
    if (!firstName || !position || !office || !age || !salary) return;
    if (firstName.length < 4) {
        pushNotification(10, 10, "Name is not correct length", "Wrong Name length", "warning");
        return;
    } else if (age > 90 || age < 18) {
        pushNotification(10, 10, "Wrong Age", "Age is a bit strange for this action", "warning");
        return;
    }
    salary = "$" + salary.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var tr = document.createElement("tr");
    [
        firstName,
        position,
        office,
        age,
        salary
    ].forEach(function(value) {
        var td = document.createElement("td");
        td.textContent = value;
        tr.appendChild(td);
    });
    tbody.appendChild(tr);
    form.reset();
    pushNotification(10, 10, "New Employee add", "New employee is successfully added to the table", "success");
});
// Notification
var pushNotification = function(posTop, posRight, title, description, type) {
    var div = document.createElement("div");
    var h2 = document.createElement("h2");
    var p = document.createElement("p");
    div.className = "notification";
    div.style.position = "absolute";
    div.style.top = posTop + "px";
    div.style.right = posRight + "px";
    div.dataset.qa = "notification";
    if (type === "success") div.className = div.className + " success";
    else if (type === "error") div.className = div.className + " error";
    else if (type === "warning") div.className = div.className + " error";
    h2.innerText = title;
    h2.className = "title";
    p.innerText = description;
    div.appendChild(h2);
    div.appendChild(p);
    document.querySelector("body").append(div);
    setTimeout(function() {
        div.style.display = "none";
    }, 4000);
};

//# sourceMappingURL=index.a1b0e597.js.map
